export const DEFAULT_APPEARANCE = 'normal';
export const VAR_COLOR = '--color';
export const VAR_BG_COLOR = '--bg-color';
export const VAR_BG_COLOR_HOVER = '--bg-color-hover';
export const VAR_BG_COLOR_ACTIVE = '--bg-color-active';